<app-gold-line input_position="start"></app-gold-line>
<div class="category_card">
  <div
    class="category_card__image"
    [style.backgroundImage]="'url(' + category.categoryImage + ')'"
  ></div>

  <div class="category_card__title inactive" #container>
    <app-category-title [categoryName]="categoryname"></app-category-title>
  </div>
</div>
<app-gold-line input_position="end"></app-gold-line>
